export const isSet =
  (msg = 'Required value.') =>
  (value: string) =>
    value !== undefined || msg;
